import React from "react"

// ⚠ DIVERGES from its copy in packages/messages/src/lib/pii.ts, which also exports
// `getPiiAttributeProps` for member data held in an attribute (`data-heap-redact-attributes`).
// Nothing here renders any, so the counterpart is left out rather than shipped unused — `lint:knip`
// fails an export with no consumer. Add it alongside the first caller that needs it.
type HeapRedactionAttributes = {
  "data-heap-redact-text": true
}

export function getPiiProps(): HeapRedactionAttributes {
  return {
    "data-heap-redact-text": true
  }
}

export function PiiText(props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>) {
  return <span {...{ ...props, ...getPiiProps() }} />
}
